import { styled } from '@linaria/react';

import Demo, {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';
import InlineCode from '@/components/InlineCode';
import TextLink from '@/components/Link/TextLink';

function FoldTransformDemo() {
  return (
    <Demo
      id="transform-rotate"
      initialValues={{
        axis: 'X',
        degrees: 0,
      }}
      controlPosition="top"
      controls={[
        <DemoRadioControl
          key="axis"
          id="axis"
          label="Axis"
          options={['X', 'Y', 'Z']}
        />,
        <DemoSliderControl
          key="degrees"
          id="degrees"
          label="Degrees"
          min={0}
          max={360}
        />,
      ]}
    >
      {({ axis, degrees }) => {
        const transform = `rotate${axis}(${degrees}deg)`;

        return (
          <Wrapper>
            <TextWrapper>
              <InlineCode
                data-force-color-mode="light"
                style={{
                  fontSize: '1.3125rem',
                }}
              >
                transform: rotate{axis}({Math.round(degrees)}deg)
              </InlineCode>
            </TextWrapper>
            <img
              width="100%"
              src="/images/folding-the-dom/cats.jpg"
              alt="cats in a basket"
              style={{ transform, maxWidth: 400 }}
            />
            <TextWrapper style={{ padding: 16, borderRadius: 4 }}>
              Photo by{' '}
              <TextLink href="https://unsplash.com/photos/YCPkW_r_6uA">
                Jari Hytönen
              </TextLink>
              .
            </TextWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
`;

const TextWrapper = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  background: var(--color-background);
`;

export default FoldTransformDemo;
